import { AnchorTag } from 'components/core/AnchorTag'
import Column from 'components/core/Column'
import { HtmlEditor } from 'components/core/HtmlEditor'
import Row from 'components/core/Row'
import Typography from 'components/core/Typography'
import { useState } from 'react'

export type SendEmailFormReadOnlyProps = {
    isShowSubjectField?: boolean
    to: string
    cc: string
    bcc: string
    subject: string
    htmlContent: string
    customComponents?: React.ReactNode
    files: File[]
}

export const SendEmailFormReadOnly = ({
    isShowSubjectField = true,
    to,
    cc,
    bcc,
    subject,
    htmlContent,
    files,
    customComponents,
}: SendEmailFormReadOnlyProps) => {
    const [expanded, setExpanded] = useState(false)

    const toParts = to.split(',')
    let toLabel = toParts.join(', ')

    const hasExpandedLink = toParts.length > 2 && !expanded

    if (hasExpandedLink) {
        toLabel = `${toParts[0]}, ${toParts[1]}, +${toParts.length - 2}`
    }

    const _onExpand = () => setExpanded(true)

    return (
        <Column fullWidth fullHeight gap="p2">
            <Row justifyContent="space-between">
                <Row gap="p1">
                    <Typography variant="body2" color="secondary">
                        To:
                    </Typography>
                    <Typography variant="body2" color="primary">
                        {toLabel}
                    </Typography>
                </Row>
                {hasExpandedLink && (
                    <AnchorTag color="secondary" onClick={_onExpand}>
                        Expand
                    </AnchorTag>
                )}
            </Row>
            {cc && (
                <Row gap="p1">
                    <Typography variant="body2" color="secondary">
                        CC:
                    </Typography>
                    <Typography variant="body2" color="primary">
                        {cc}
                    </Typography>
                </Row>
            )}
            {bcc && (
                <Row gap="p1">
                    <Typography variant="body2" color="secondary">
                        BCC:
                    </Typography>
                    <Typography variant="body2" color="primary">
                        {bcc}
                    </Typography>
                </Row>
            )}
            {isShowSubjectField && (
                <Row gap="p1">
                    <Typography variant="body2" color="secondary">
                        Subject:
                    </Typography>
                    <Typography variant="body2" color="primary">
                        {subject}
                    </Typography>
                </Row>
            )}
            <HtmlEditor
                readOnly
                fullHeight
                value={htmlContent}
                fixedHeight="200px"
                toolbarOptions={[]}
            />
            {customComponents}
            {files.length > 0 && (
                <Row gap="p1" alignItems="center">
                    {files.length > 0 && (
                        <Typography color="primary" variant="body2">
                            {files.map((f) => f.name).join(', ')}
                        </Typography>
                    )}
                </Row>
            )}
        </Column>
    )
}
